<template>
<b-modal ref="saveCompositionModal"
  centered 
  title="Zapisz kompozycję" 
  :visible="saveCompositionWindowVisible"
  @show="onShow" 
  @hidden="hide">
  <b-form>
    <b-form-group label="Nazwa kompozycji">
      <small class="text-danger" v-show="dataErrors.name">Należy podać nazwę kompozycji.</small>
      <b-form-input v-model="name" :class="{'is-invalid': dataErrors.name}" maxlength="255"></b-form-input>
    </b-form-group>
  </b-form>
  <div slot="modal-footer">
    <b-btn variant="primary" @click="saveComposition">Zapisz</b-btn>
    <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
  </div>     
</b-modal>
</template>

<script>
import { WINDOW_SAVE_COMPOSITION_HIDE } from "../store/mutations.type";
import { COMPOSITIONS_SAVE } from "../store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "SaveCompositionWindow",
  data: function() {
    return {
      name: undefined,
      dataErrors: {
        name: false
      }
    };
  },
  computed: {
    ...mapGetters(["saveCompositionWindowVisible"])
  },
  methods: {
    saveComposition(e) {
      if (!this.validate()) {
        e.preventDefault();
        return;
      }

      const composition = { name: this.name };
      this.$store.dispatch(COMPOSITIONS_SAVE, { composition: composition, userEmail: this.contextEmail });

      this.hide();
    },
    hide() {
      this.$store.commit(WINDOW_SAVE_COMPOSITION_HIDE);
    },
    onShow() {
      this.dataErrors.name = false;
      this.name = undefined;
    },
    validate() {
      this.dataErrors.name = !this.name;

      return !this.dataErrors.name;
    }
  }
};
</script>
